module.exports = __webpack_public_path__ + "static/media/step5a.3fad80db.jpg";